<template>
  <div class="confirm-wrap">
    <div class="confirm-title">
      <span>{{ $t('提示') }}</span>
      <i class="el-icon-close" @click="handleCancel()"></i>
    </div>
    <div class="confirm-cont">
      {{ text }}
    </div>
    <div class="confirm-footer">
      <el-button size="small" @click="handleCancel()">{{ $t('取消') }}</el-button>
      <el-button size="small" type="primary" @click="handleConfirm()">{{ $t('确认') }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AllshowConfirm',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>
<style lang="scss" scoped>
.confirm-wrap {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 200px;
  background-color: #fff;
  z-index: 99999;
  border-radius: 12px;
  overflow: hidden;
  padding: 0 12px;

  .confirm-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 40px;
    border-bottom: 1px solid #f2f2f2;
  }

  .confirm-cont {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: content;
    font-size: 16px;
  }

  .confirm-footer {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.el-icon-close {
  cursor: pointer;
}
</style>
